/**
 * move contact form into wrapper
 */
import Splide from '@splidejs/splide';

(() => {
  const contactSource = document.querySelector('.industries-contact-source');
  const contactLocations = document.querySelector('.industries-contact-location');
  if (contactSource && contactLocations) {
    contactLocations.append(contactSource);
  }
})();

/**
 * move tabbed content into wrapper
 */
(() => {
  const tabbedContent = document.querySelector('.industries-tabbed');
  if (!tabbedContent) return;

  const wrapperTabs = tabbedContent.querySelector('.tab-header');
  const wrapperContent = tabbedContent.querySelector('.tab-content');

  document.querySelectorAll('.tab-content-source')
    .forEach((source, index) => {
      const tabTitle = source.querySelector('.tab-title');
      if (index === 0) {
        tabTitle.classList.add('nActive');
        source.classList.add('nActive');
      }
      wrapperTabs.append(tabTitle);
      wrapperContent.append(source);
    });

  if (document.querySelector('.tab-content-source.nActive')) {
    wrapperTabs.classList.add('move');
  }

  document.querySelectorAll('.tab-header .tab-title')
    .forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelectorAll('.tab-header .tab-title').forEach((t) => t.classList.remove('nActive'));
        document.querySelectorAll('.tab-content-source').forEach((source) => source.classList.remove('nActive'));
        tab.classList.add('nActive');
        document.querySelectorAll('.tab-content-source')[index].classList.add('nActive');

        if (index === 0) {
          wrapperTabs.classList.add('move');
        } else {
          wrapperTabs.classList.remove('move');
        }
      });
    });
})();

(() => {
  document.querySelectorAll('.overview-carousel').forEach((item) => {
    const slider = new Splide(item, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: 20,
      pagination: false,
      arrows: false,
      autoplay: false,
      breakpoints: {
        1250: {
          perPage: 3,
        },
        768: {
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
